document.addEventListener('DOMContentLoaded', function() {
  // SKU on PDP based on Variant select 
  const variantSku_container = document.getElementById("product-variant-sku");
  const urlParams = new URLSearchParams(window.location.search);

  document.addEventListener('variant-sku', (event) => {
    if (!variantSku_container) return;
    const skuValue = event.detail.sku;
    console.log('skuValue: ', skuValue);
    variantSku_container.innerHTML = skuValue.split('_')[1];
 });

  const setProductEnquiryModalState = (modal, isOpen) => {
    if (!modal) return;

    modal.classList.toggle('is-open', isOpen);
    modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.body.classList.toggle('overflow-hidden', isOpen);
  };

  if (urlParams.get('contact_posted') === 'true') {
    document.querySelectorAll('[data-product-enquiry-success-container]').forEach((container) => {
      if (!container.innerHTML.trim()) {
        container.innerHTML = `<p class="form-status form-status-list form__message" tabindex="-1" autofocus>
          Thanks for contacting us. We'll get back to you as soon as possible.
        </p>`;
      }

      container.hidden = false;

      const modal = container.closest('.modal');
      const fields = modal?.querySelector('.contact__fields');
      const actions = modal?.querySelector('.contact__button');

      if (fields) fields.hidden = true;
      if (actions) actions.hidden = true;
      if (modal) setProductEnquiryModalState(modal, true);
    });
  }

  document.querySelectorAll('[data-product-enquiry-auto-open="true"]').forEach((modal) => {
    setProductEnquiryModalState(modal, true);
  });

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-product-enquiry-open]');
    if (openTrigger) {
      event.preventDefault();
      const modal = document.getElementById(openTrigger.dataset.productEnquiryOpen);
      setProductEnquiryModalState(modal, true);
      return;
    }

    const closeTrigger = event.target.closest('[data-product-enquiry-close]');
    if (closeTrigger) {
      const modal = closeTrigger.closest('.modal');
      if (event.target === closeTrigger) {
        event.preventDefault();
        setProductEnquiryModalState(modal, false);
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openModal = document.querySelector('.modal.is-open');
    if (openModal) setProductEnquiryModalState(openModal, false);
  });

});
  